import React from 'react';
import { Modal, Button } from 'react-bootstrap'; // Using react-bootstrap for styling

// Define types for the props of the ConfirmModal component
interface IConfirmModalProps {
  show: boolean;                // Controls the visibility of the modal
  title: string;                // dialogue title
  message: string;              // The message to display in the modal
  onConfirm: () => void;        // Callback for when "OK" is clicked
  onCancel: () => void;         // Callback for when "Cancel" is clicked
}

const ConfirmModal = (props: IConfirmModalProps) => {
  return (
    <Modal show={props.show} onHide={props.onCancel} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p dangerouslySetInnerHTML={{__html: props.message}}></p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={props.onConfirm}>
          OK
        </Button>
        <Button variant="secondary" onClick={props.onCancel}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
